module.exports = __webpack_public_path__ + "static/media/chat03.ce5c79c4.png";